import React from 'react'
import './CorporateProductCart.css'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import Footer from '../../../component/Footer/Footer';
import CorporateLayoutWrapper from '../../../component/CorporateLayoutWrapper/';
import { updateCorporateCart, doCorporateCartUpdateRes } from '../../../action/CorporateCartUpdateAction';
import { corporateAddressShowList, doCorporateShowAddressListRes } from '../../../action/CorporateShowAddressListAction';
import emptyCart from '../../../assets/images/IlustrasiCart.png'
import { showCorporateCartList, doCorporateCartListRes } from "../../../action/CorporateCartListAction";
import { corporateAddressAdd, doCorporateAddAddressRes } from "../../../action/CorporateAddAddressAction";
import { corporateProductRemove, doCorporateProductRemoveRes } from '../../../action/CorporateProductRemoveAction';
import { corporateAddressDelete, doCorporateDeleteAddressRes } from "../../../action/CorporateDeleteAddressAction";
import { uploadCsv, doCsvUploadRes } from "../../../action/CsvUploadAction";
import { showBillingAddress, doShowBillingRes } from '../../../action/ShowBillingAction';
import { updateBillingAdd, doBillingUpdateRes } from '../../../action/billingUpdateAction';
import loaderImg from "../../../assets/images/loader-example.gif";
import Loader from "react-loader-advanced";
import Swal from 'sweetalert2'
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { Modal } from "react-responsive-modal";
import { Link } from 'react-router-dom';
import sampleCsv from '../../../assets/file/sample-csv.csv';



class CorporateProductCart extends React.PureComponent {

    constructor() {
        super();
        this.state = {
            isAddressActive: 0,
            addressBtn: 'officeAddress',
            addressShowBtn: false,
            popUpEmployee: false,
            popUpOffice: false,
            popUpAddressList: false,
            csvFile: '',
            dataProduct: [],
            qty: 1,
            cartCheck: false,
            updateCart: false,
            removeCart: false,
            removeAdd: false,
            removeAddress: false,
            addAddress: false,
            sub_total: '',
            showAddressData: [],
            csvData: [],
            firstName: '',
            lastName: '',
            company: '',
            streetAddress: '',
            city: '',
            stateProvince: '',
            postalCode: '',
            phoneNumber: '',
            isLoader: false,
            addradio: localStorage.getItem('addressId') ? localStorage.getItem('addressId') : 0,

            billingName: '',
            billingStreetaddress: '',
            billingCity: '',
            billingPostalcode: '',
            billingStateProvince: '',

            copyChecked: false,
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    componentDidMount() {
        const cartData = {
            user_id: localStorage.getItem("userId"),
        };
        this.props.showCorporateCartList(cartData);

        // const cartAddress = {
        //     user_id: localStorage.getItem("userId"),
        // };

        this.setState(
            {
                isLoader: true,
                popUpAddressList: false,
                popUpOffice: false
            }
        );
        // this.props.corporateAddressShowList(cartAddress);
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.doCorporateCartListRes && nextProps.doCorporateCartListRes.user) {
            if (nextProps.doCorporateCartListRes.user && nextProps.doCorporateCartListRes.user.CorporateCartListRes) {
                if (nextProps.doCorporateCartListRes.user.CorporateCartListRes && nextProps.doCorporateCartListRes.user.CorporateCartListRes.result === true) {
                    if (nextProps.doCorporateCartListRes.user.CorporateCartListRes.cart === null) {
                        this.props.history.push('/corporate-tab')
                    } else {
                        this.setState({
                            dataProduct: nextProps.doCorporateCartListRes.user.CorporateCartListRes.cart,
                            sub_total: nextProps.doCorporateCartListRes.user.CorporateCartListRes.sub_total,
                            isLoader: false,
                            popUpOffice: false
                        })
                    }
                } else {
                    this.setState({
                        isLoader: false,
                    })
                }
            }
        }

        if (nextProps.doCorporateCartUpdateRes && nextProps.doCorporateCartUpdateRes.user) {
            if (nextProps.doCorporateCartUpdateRes.user && nextProps.doCorporateCartUpdateRes.user.CorporateCartUpdateRes) {
                if (nextProps.doCorporateCartUpdateRes.user.CorporateCartUpdateRes && nextProps.doCorporateCartUpdateRes.user.CorporateCartUpdateRes.result === true && this.state.updateCart === true) {
                    this.setState({
                        cartCheck: true,
                        updateCart: false,
                        isLoader: false,
                        popUpOffice: false
                    }, () => {
                        if (this.state.cartCheck) {
                            const cartData = {
                                user_id: localStorage.getItem('userId')
                            }
                            this.props.showCorporateCartList(cartData)
                        }
                    })
                } else {
                    this.setState({
                        isLoader: false,
                    })
                }
            }
        }

        if (nextProps.doCorporateProductRemoveRes && nextProps.doCorporateProductRemoveRes.user) {
            if (nextProps.doCorporateProductRemoveRes.user && nextProps.doCorporateProductRemoveRes.user.CorporateProductRemoveRes) {
                if (nextProps.doCorporateProductRemoveRes.user.CorporateProductRemoveRes && nextProps.doCorporateProductRemoveRes.user.CorporateProductRemoveRes.results === true && this.state.removeCart === true) {
                    this.setState({
                        cartCheck: true,
                        removeCart: false,
                        isLoader: false,
                        popUpOffice: false
                    }, () => {
                        if (this.state.cartCheck) {
                            const cartData = {
                                user_id: localStorage.getItem('userId')
                            }
                            this.props.showCorporateCartList(cartData)
                        }
                    })
                } else {
                    this.setState({
                        isLoader: false,
                    })
                }
            }
        }

        if (nextProps.doCorporateShowAddressListRes && nextProps.doCorporateShowAddressListRes.user) {
            if (nextProps.doCorporateShowAddressListRes.user && nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes) {

                if (nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes && nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes.result === true) {
                    localStorage.setItem('addressId', nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes.address[0].id)
                    localStorage.setItem('addressName', nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes.address[0].first_name + ' ' + nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes.address[0].last_name)
                    this.setState({
                        isAddressActive: nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes.address[0].id,
                        showAddressData: nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes.address,
                        addressID: nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes.address[0].id,
                        isLoader: false,
                    })
                } else if (nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes && nextProps.doCorporateShowAddressListRes.user.CorporateShowAddressListRes.result === false) {
                    this.setState({
                        popUpAddressList: false,
                        popUpOffice: true,
                        showAddressData: [],
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doCorporateAddAddressRes && nextProps.doCorporateAddAddressRes.user) {
            if (nextProps.doCorporateAddAddressRes.user && nextProps.doCorporateAddAddressRes.user.CorporateAddAddressRes) {
                if (nextProps.doCorporateAddAddressRes.user.CorporateAddAddressRes && nextProps.doCorporateAddAddressRes.user.CorporateAddAddressRes.result === true && this.state.addAddress) {
                    this.setState({
                        popUpOffice: false,
                        addAddress: false,
                        isLoader: false,
                        firstName: '',
                        lastName: '',
                        company: '',
                        streetAddress: '',
                        city: '',
                        stateProvince: '',
                        postalCode: '',
                        phoneNumber: '',

                    }, () => {
                        if (this.state.addAddress) {
                            const cartAddress = {
                                user_id: localStorage.getItem("userId"),
                            };
                            this.props.corporateAddressShowList(cartAddress);
                        }
                    })
                }
            }
        }

        if (nextProps.doCorporateDeleteAddressRes && nextProps.doCorporateDeleteAddressRes.user) {
            if (nextProps.doCorporateDeleteAddressRes.user && nextProps.doCorporateDeleteAddressRes.user.CorporateDeleteAddressRes) {
                if (nextProps.doCorporateDeleteAddressRes.user.CorporateDeleteAddressRes && nextProps.doCorporateDeleteAddressRes.user.CorporateDeleteAddressRes.results === true && this.state.removeAdd === true) {

                    this.setState({
                        removeAddress: true,
                        removeAdd: false,
                        popUpAddressList: false,
                        isLoader: false,
                    }, () => {
                        if (this.state.removeAddress) {
                            const cartAddress = {
                                user_id: localStorage.getItem("userId"),
                            };
                            this.props.corporateAddressShowList(cartAddress);
                        }
                    })
                    localStorage.removeItem("addressName")
                    localStorage.removeItem("addressId")

                }
            }
        }

        if (nextProps.doCsvUploadRes && nextProps.doCsvUploadRes.user) {
            if (nextProps.doCsvUploadRes.user && nextProps.doCsvUploadRes.user.CsvUploadRes) {
                if (nextProps.doCsvUploadRes.user.CsvUploadRes && nextProps.doCsvUploadRes.user.CsvUploadRes.success === true) {
                    this.setState({
                        csvData: nextProps.doCsvUploadRes.user.CsvUploadRes.json_data,
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doShowBillingRes && nextProps.doShowBillingRes.user) {
            if (nextProps.doShowBillingRes.user && nextProps.doShowBillingRes.user.ShowBillingRes) {
                if (nextProps.doShowBillingRes.user.ShowBillingRes && nextProps.doShowBillingRes.user.ShowBillingRes.result === true) {

                    this.setState({
                        popUpOffice: true,
                        billingName: nextProps.doShowBillingRes.user.ShowBillingRes.billing.name,
                        billingStreetaddress: nextProps.doShowBillingRes.user.ShowBillingRes.billing.address,
                        billingCity: nextProps.doShowBillingRes.user.ShowBillingRes.billing.city,
                        billingPostalcode: nextProps.doShowBillingRes.user.ShowBillingRes.billing.pincode,
                        billingStateProvince: nextProps.doShowBillingRes.user.ShowBillingRes.billing.state,
                    })
                }
            }
        }

        if (nextProps.doBillingUpdateRes && nextProps.doBillingUpdateRes.user) {
            if (nextProps.doBillingUpdateRes.user && nextProps.doBillingUpdateRes.user.UpdateBillingRes) {
                if (nextProps.doBillingUpdateRes.user.UpdateBillingRes && nextProps.doBillingUpdateRes.user.UpdateBillingRes.success === true && this.state.addAddress) {
                    this.setState({
                        popUpOffice: false,
                        addAddress: false,
                        isLoader: false
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }
    }



    clickEmployeeAddress = () => {
        this.setState({
            popUpEmployee: true
        })
    }

    onCloseEmployeeModal = () => {
        this.setState({
            popUpEmployee: false
        })
    }



    onCloseOfficeModal = () => {
        this.setState({
            popUpOffice: false
        })
    }

    onCloseAddressListModal = () => {
        this.setState({
            popUpAddressList: false
        })
    }

    processData = (dataFile) => {
        let data = {
            csvUpload: dataFile
        }
        this.setState(
            {
                isLoader: true,
                popUpEmployee: false
            }
        )

        this.props.uploadCsv(data)



    }

    changeUploadCsv = (e) => {
        const file = e.target.files[0];


        this.setState({
            csvFile: file
        })
    }




    decQty = (i) => {
        let data = this.state.dataProduct;
        if (data[i].qty > 1) {
            data[i].qty--
            this.setState({
                dataProduct: [...data]
            })
            const decdata = {
                cart_id: data[i].id,
                qty: data[i].qty,
                image_json: '',
                text_json: '',
                thumbnail: data[i].thumbnail ? data[i].thumbnail : '',
                thumbnail_back: data[i].thumbnail_back ? data[i].thumbnail_back : '',
                brand: '',
                model: '',
                thumbnail_pocket: data[i].thumbnail_pocket ? data[i].thumbnail_pocket : '',
                isAddressSubmited: false,
            }
            this.setState({
                updateCart: true,
                isLoader: true
            })
            this.props.updateCorporateCart(decdata)
        }

    }
    incQty = (i) => {
        let data = this.state.dataProduct;
        data[i].qty++
        this.setState({
            dataProduct: [...data]
        })
        const incdata = {
            cart_id: data[i].id,
            qty: data[i].qty,
            image_json: '',
            text_json: '',
            thumbnail: data[i].thumbnail ? data[i].thumbnail : '',
            thumbnail_back: data[i].thumbnail_back ? data[i].thumbnail_back : '',
            brand: '',
            model: '',
            thumbnail_pocket: data[i].thumbnail_pocket ? data[i].thumbnail_pocket : '',
            isAddressSubmited: false,
        }
        this.setState({
            updateCart: true,
            isLoader: true,
            popUpAddressList: false,
            popUpOffice: false
        })
        this.props.updateCorporateCart(incdata)
    }

    SubTotal = () => {
        this.state.cartViewData && this.state.cartViewData.map((item) => (
            this.setState({
                totalPrice: this.state.totalPrice + (item.price * item.qty)
            })
        ))
    }

    removetItemCart = (id) => {
        const data = {
            cart_id: id
        }
        this.setState({
            removeCart: true,
            isLoader: true,
        })
        this.props.corporateProductRemove(data)
    }

    showAddressBtn = (e) => {
        if (e.target.value === 'employeeAddress') {
            this.setState({
                addressShowBtn: true,
                addressBtn: 'employeeAddress',
                popUpEmployee: true
            })
        } else {
            this.setState({
                addressShowBtn: false,
                addressBtn: 'officeAddress',
                popUpAddressList: true,
                isLoader: true
            })

            const cartAddress = {
                user_id: localStorage.getItem("userId"),
            };
            this.props.corporateAddressShowList(cartAddress);

        }

    }

    showPopUpAddressList = () => {
        this.setState({
            popUpAddressList: true,
            isLoader: true
        })
        const cartAddress = {
            user_id: localStorage.getItem("userId"),
        };
        this.props.corporateAddressShowList(cartAddress);
    }

    addressvalidate(values) {
        const errors = {};
        if (values.firstName && values.firstName.trim() === '') {
            errors.firstName = '*Please enter firstName';
        } else if (values.firstName === undefined) {
            errors.firstName = '*Please enter firstName';
        } else if (values.firstName === '') {
            errors.firstName = '*Please enter firstName';
        }

        if (values.lastName && values.lastName.trim() === '') {
            errors.lastName = '*Please enter lastName';
        } else if (values.lastName === null) {
            errors.lastName = '*Please enter lastName';
        } else if (values.lastName === undefined) {
            errors.lastName = '*Please enter lastName';
        } else if (values.lastName === '') {
            errors.lastName = '*Please enter lastName';
        }

        if (values.company && values.company.trim() === '') {
            errors.company = '*Please enter company';
        } else if (values.company === null) {
            errors.company = '*Please enter company';
        } else if (values.company === undefined) {
            errors.company = '*Please enter company';
        } else if (values.company === '') {
            errors.company = '*Please enter company';
        }

        if (values.streetAddress && values.streetAddress.trim() === '') {
            errors.streetAddress = '*Please enter streetAddress';
        } else if (values.streetAddress === null) {
            errors.streetAddress = '*Please enter streetAddress';
        } else if (values.streetAddress === undefined) {
            errors.streetAddress = '*Please enter streetAddress';
        } else if (values.streetAddress === '') {
            errors.streetAddress = '*Please enter streetAddress';
        }

        if (values.city && values.city.trim() === '') {
            errors.city = '*Please enter city';
        } else if (values.city === null) {
            errors.city = '*Please enter city';
        } else if (values.city === undefined) {
            errors.city = '*Please enter city';
        } else if (values.city === '') {
            errors.city = '*Please enter city';
        }

        if (values.postalCode && values.postalCode.trim() === '') {
            errors.postalCode = '*Please enter postalCode';
        } else if (values.postalCode === null) {
            errors.postalCode = '*Please enter postalCode';
        } else if (values.postalCode === undefined) {
            errors.postalCode = '*Please enter postalCode';
        } else if (values.postalCode === '') {
            errors.postalCode = '*Please enter postalCode';
        }


        if (values.phoneNumber && values.phoneNumber.trim() === '') {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber === null) {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber === undefined) {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber === '') {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber.length !== 10) {
            errors.phoneNumber = '*Please enter valid phone number.';
        }


        if (values.stateProvince && values.stateProvince.trim() === '') {
            errors.stateProvince = '*Please enter state';
        } else if (values.stateProvince === null) {
            errors.stateProvince = '*Please enter state';
        } else if (values.stateProvince === undefined) {
            errors.stateProvince = '*Please enter state';
        } else if (values.stateProvince === '') {
            errors.stateProvince = '*Please enter state';
        }

        if (values.billingName && values.billingName.trim() === '') {
            errors.billingName = '*Please enter billing name';
        } else if (values.billingName === undefined) {
            errors.billingName = '*Please enter billing name';
        } else if (values.billingName === '') {
            errors.billingName = '*Please enter billing name';
        }

        if (values.billingStreetaddress && values.billingStreetaddress.trim() === '') {
            errors.billingStreetaddress = '*Please enter billing address';
        } else if (values.billingStreetaddress === null) {
            errors.billingStreetaddress = '*Please enter billing address';
        } else if (values.billingStreetaddress === undefined) {
            errors.billingStreetaddress = '*Please enter billing address';
        } else if (values.billingStreetaddress === '') {
            errors.billingStreetaddress = '*Please enter billing address';
        }

        if (values.billingCity && values.billingCity.trim() === '') {
            errors.billingCity = '*Please enter billing city';
        } else if (values.billingCity === null) {
            errors.billingCity = '*Please enter billing city';
        } else if (values.billingCity === undefined) {
            errors.billingCity = '*Please enter billing city';
        } else if (values.billingCity === '') {
            errors.billingCity = '*Please enter billing city';
        }

        if (values.billingStateProvince && values.billingStateProvince.trim() === '') {
            errors.billingStateProvince = '*Please enter state';
        } else if (values.billingStateProvince === null) {
            errors.billingStateProvince = '*Please enter state';
        } else if (values.billingStateProvince === undefined) {
            errors.billingStateProvince = '*Please enter state';
        } else if (values.billingStateProvince === '') {
            errors.billingStateProvince = '*Please enter state';
        }

        if (values.billingPostalcode && values.billingPostalcode.trim() === '') {
            errors.billingPostalcode = '*Please enter billing postal code';
        } else if (values.billingPostalcode === null) {
            errors.billingPostalcode = '*Please enter billing postal code';
        } else if (values.billingPostalcode === undefined) {
            errors.billingPostalcode = '*Please enter billing postal code';
        } else if (values.billingPostalcode === '') {
            errors.billingPostalcode = '*Please enter billing postal code';
        }


        return errors;
    }

    AddressHandelSubmit = e => {
        e.preventDefault();
        this.setState({
            isAddressSubmited: true,
        }, () => { });
        this.addressvalidate(this.state);
        const errors = this.addressvalidate(this.state);
        if (Object.keys(errors).length === 0) {
            let requestData = {
                user_id: localStorage.getItem('userId'),
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                company: this.state.company,
                streetAddress: this.state.streetAddress,
                city: this.state.city,
                postalCode: this.state.postalCode,
                phoneNumber: this.state.phoneNumber,
                stateProvince: this.state.stateProvince
            }
            // this.setState({
            //     isLoader: true
            // })
            let billingData = {
                user_id: localStorage.getItem('userId'),
                name: this.state.billingName,
                address: this.state.billingStreetaddress,
                city: this.state.billingCity,
                state: this.state.billingStateProvince,
                pincode: this.state.billingPostalcode
            }
            this.setState({
                addAddress: true,
                isLoader: true
            })
            this.props.updateBillingAdd(billingData)
            this.props.corporateAddressAdd(requestData)
        }
    }

    clickNewAddress() {
        this.setState({
            popUpOffice: true,
            popUpAddressList: false,
        })

        const shipdata = {
            user_id: localStorage.getItem('userId')
        }
        this.props.showBillingAddress(shipdata)
    }

    deleteAddress = (id) => {
        const data = {
            add_id: id
        }
        // this.setState({
        //     isLoader: true
        // })
        this.setState({
            removeAdd: true,
            isLoader: true
        })
        this.props.corporateAddressDelete(data)

    }

    addressHandelChange = (e) => {
        this.setState({
            addradio: e.id,
            popUpAddressList: false
        })

        localStorage.setItem('addressId', e.id)
        localStorage.setItem('addressName', e.first_name + ' ' + e.last_name)

    }

    checkOutNextPage = () => {
        if (this.state.addressBtn === 'employeeAddress') {
            this.props.history.push('/corporate-checkout', {
                addressBtn: this.state.addressBtn,
                csvData: this.state.csvData,
            })
        } else {
            if (localStorage.getItem('addressName') && localStorage.getItem('addressId')) {
                this.props.history.push('/corporate-checkout', {
                    addressId: this.state.addressID
                })
            } else {
                Swal.fire({
                    title: "Please select one address",
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    timer: 1000
                })
            }
        }

    }

    handleChangeCheckBox = e => {
        if (e.target.checked === true) {
            this.setState({
                copyChecked: e.target.checked,
                firstName: this.state.billingName,
                streetAddress: this.state.billingStreetaddress,
                city: this.state.billingCity,
                stateProvince: this.state.billingStateProvince,
                postalCode: this.state.billingPostalcode
            });
        } else {
            this.setState({
                copyChecked: false,
                firstName: '',
                streetAddress: '',
                city: '',
                stateProvince: '',
                postalCode: ''
            });
        }

    }


    render() {
        const errors = this.addressvalidate(this.state);
        const { isAddressSubmited } = this.state;
        const closeIcon = (
            <i className="fa fa-times closeIconbg add-clr-btn" aria-hidden="true"></i>
        );
        const spinner = <span><img src={loaderImg} alt="" /></span>;
        return (
            <React.Fragment>
                <div className="page-wrapper">
                    <CorporateLayoutWrapper />
                    <Loader show={this.state.isLoader} message={spinner}>
                        <main className="main main-top">
                            <nav aria-label="breadcrumb" className="breadcrumb-nav mb-1">
                                <div className="container">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/corporate-tab">Corporate</a></li>
                                        <li className="breadcrumb-item active" aria-current="page">Corporate Cart</li>
                                    </ol>
                                </div>
                                {/* End .container  */}
                            </nav>

                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <div className="cart-table-container">
                                            {this.state.dataProduct === null ?
                                                <div className="text-center">
                                                    <img src={emptyCart} alt="emptyCart" width={500} height={500} />
                                                    <h4>Empty Cart</h4>
                                                </div>

                                                :
                                                <table className="table table-cart">

                                                    <thead className="thead-rsp re-adjst">
                                                        <tr className="re-adjust">
                                                            <th className="product-col adjst-prodct re-adjust-product">Product</th>
                                                            <th className="price-col">Price</th>
                                                            <th className="qty-col">Qty</th>
                                                            <th>Subtotal</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.dataProduct && this.state.dataProduct.map((item, i) => (

                                                            <tr className="product-row" key={i}>
                                                                <td className="product-col img-size1">
                                                                    <figure className="product-image-container prodct-img">
                                                                        {/* <a href="/" > */}

                                                                        <img src={item.thumbnail || item.thumbnail_back || item.thumbnail_pocket} className="product-image" alt="product" />
                                                                        {/* </a> */}
                                                                    </figure>
                                                                    <h2 className="product-title item-product-name">
                                                                        {item.name}
                                                                    </h2>
                                                                </td>
                                                                <td className="itm item-sign"><i className="fa fa-rupee-sign"></i> {item.price}.00</td>
                                                                <td>
                                                                    <div className="product-single-qty btn-qty" style={{ "display": "flex" }}>

                                                                        <button className="btn btn-outline qty-mns " disabled={item.qty === 1} onClick={() => this.decQty(i)}>-</button>

                                                                        <input className="horizontal-quantity form-control qty-input" type="text" value={item.qty} readOnly />

                                                                        <button className="btn btn-outline" onClick={() => this.incQty(i)}>+</button>
                                                                    </div>
                                                                </td>
                                                                <td><i className="fa fa-rupee-sign"></i>{item.price * item.qty}.00</td>




                                                                <td className='pad-0'><i className="fa fa-trash-alt del-view-cart" onClick={() => this.removetItemCart(item.id)}></i></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            }
                                            <table>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan="6" className="clearfix">
                                                            <div className="float-left">
                                                                <a href="/" className="btn btn-outline-secondary">Continue Shopping</a>
                                                            </div>
                                                            {/* End .float-left */}

                                                            {/* <div className="float-right">
                                                        <a href="/cart" className="btn btn-outline-secondary btn-clear-cart">Clear Shopping Cart</a>
                                                        <a href="/cart" className="btn btn-outline-secondary btn-update-cart">Update Shopping Cart</a>
                                                    </div> */}
                                                            {/* End .float-right */}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>

                                        </div>

                                    </div>


                                    <div className="col-lg-4">
                                        {this.state.cartViewData !== null ?
                                            <div className="cart-summary">
                                                <h3>CART TOTALS</h3>
                                                <table className="table table-totals">
                                                    <tbody>
                                                        <tr>
                                                            <td>Subtotal</td>
                                                            <td><i className="fa fa-rupee-sign"></i>{this.state.sub_total}.00</td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td>Order Total</td>

                                                            <td><i className="fa fa-rupee-sign"></i> {this.state.sub_total}.00</td>
                                                        </tr>
                                                    </tfoot>
                                                </table>

                                                <ul>
                                                    <li>
                                                        {(this.state.showAddressData.length > 0 || localStorage.getItem('addressName')) ? <div className='main-cursor-menu width-80' onClick={() => this.showPopUpAddressList()}>

                                                            <label className="pointer">{localStorage.getItem('addressName')}</label>
                                                            <i className="fas fa-pen flot-right" aria-hidden="true"></i>
                                                        </div>
                                                            :
                                                            <>
                                                                <input type="radio" className="input-radio" name="payment_method" onClick={(e) => this.showAddressBtn(e)} value="officeAddress" readOnly />
                                                                <label className="pl-5">Office Address</label>
                                                                <br />
                                                            </>
                                                        }

                                                        <div>
                                                            <input type="radio" className="input-radio" name="payment_method" onClick={(e) => this.showAddressBtn(e)} value="employeeAddress" readOnly />
                                                            <label className="pl-5" >Employee Address</label>
                                                        </div>

                                                    </li>

                                                </ul>

                                                {/* <div className="checkout-methods checkout-btn">
                                                {
                                                    this.state.addressShowBtn ?
                                                        <div className="btn btn-block btn-sm btn-primary show-color" onClick={() => this.clickEmployeeAddress()}>Checkout Employee Address</div>
                                                        :
                                                        <div className="btn btn-block btn-sm btn-primary show-color" onClick={() => this.clickOfficeAddress()}>Checkout Office Address</div>
                                                }

                                            </div> */}

                                                <div className="checkout-methods checkout-btn mt-1">
                                                    <div className="btn btn-block btn-sm btn-primary show-color" onClick={() => this.checkOutNextPage()}>Go to Checkout</div>

                                                </div>

                                            </div> : ''}

                                    </div>
                                </div>
                                {/* End .row  */}
                            </div>
                            {/* End .container  */}
                            <div className="mb-6"></div>
                            {/* margin */}
                        </main>
                    </Loader>
                    {/* End .main */}
                    {/* {this.state.showAddressData !== null && */}
                    <Modal open={this.state.popUpAddressList} onClose={this.onCloseAddressListModal} closeIcon={closeIcon} >

                        <div className="row bg-color-login mrg-0">
                            <div className="col-lg-12 mt-5">
                                <ul className="checkout-steps">
                                    <li>
                                        <h2 className="step-title">Address</h2>

                                        <div className="shipping-step-addresses">
                                            {
                                                this.state.showAddressData && this.state.showAddressData.map((item, i) => (
                                                    <div className="shipping-address-box pointer" key={i} onClick={() => this.addressHandelChange(item)}>
                                                        <i className="fa fa-trash-alt del-add" onClick={() => this.deleteAddress(item.id)}></i>
                                                        <address>
                                                            {item.first_name} {item.last_name} <br />
                                                            {item.street_address},{item.city} {item.zip_code}<br />
                                                            {item.state} <br />
                                                            {item.phone_number}<br />

                                                        </address>

                                                        {/* <input type="radio" name="addradio" onClick={() => this.addressHandelChange(item)} checked={(this.state.addradio === item.id) ? true : ((i === 0) ? true  : false)} value={item.id} readOnly /> */}

                                                        <input type="radio" name="addradio" onClick={() => this.addressHandelChange(item)} checked={(this.state.isAddressActive === item.id) ? true : false} value={item.id} readOnly />

                                                    </div>
                                                ))
                                            }
                                        </div>
                                        {/* */}
                                        <div onClick={() => this.clickNewAddress()} ><a href="/" className="btn btn-sm btn-outline-secondary btn-new-address " data-toggle="modal" data-target="#addressModal" >+ New Address</a></div>
                                    </li>
                                </ul>
                            </div>
                            {/* End .col-lg-8 */}
                        </div>
                    </Modal>
                    {/* } */}

                    <Modal open={this.state.popUpEmployee} onClose={this.onCloseEmployeeModal} closeIcon={closeIcon} >


                        <form className="bg-color-login">
                            <div className="modal-header">
                                <h3 className="modal-title" id="addressModalLabel">Employee Address</h3>
                            </div>


                            <div className="modal-body">
                                <input type="file" icon='file text outline' label='Upload CSV' accept='.csv' placeholder="Upload Csv" name="csvFile" onChange={(e) => this.changeUploadCsv(e)} className="upload-csv" />
                            </div>
                            {/* End .modal-body  */}
                            <div className='download-csv'>
                                <Link to={sampleCsv} target="_blank" className='download-fnt-clr' download>Please download sample csv file</Link>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-sm" data-dismiss="modal" onClick={this.onCloseEmployeeModal} >Cancel</button>
                                <button type="button" className="btn btn-primary btn-sm show-color" onClick={() => this.processData(this.state.csvFile)} disabled={!this.state.csvFile}>Upload Files</button>
                            </div>
                            {/* End .modal-footer */}
                        </form>
                    </Modal>

                    <Modal open={this.state.popUpOffice} onClose={this.onCloseOfficeModal} closeIcon={closeIcon} >


                        <form onSubmit={this.AddressHandelSubmit} className="bg-color-login">
                            <div className="modal-header">
                                <h3 className="modal-title" id="addressModalLabel">Office Address</h3>
                            </div>
                            {/* End .modal-header */}


                            <div className="modal-body">

                                <label className="modal-title pad-10">Billing Address</label>
                                <div className="form-group required-field">

                                    <label>Name </label>
                                    <input type="text" className="form-control form-control-sm" name="billingname" onChange={(e) => this.setState({ billingName: e.target.value })} value={this.state.billingName || ''} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.billingName}</span>}

                                </div>
                                <div className="form-group required-field">

                                    <label>Street Address </label>
                                    <input type="text" className="form-control form-control-sm" name="billingstreetadd" onChange={(e) => this.setState({ billingStreetaddress: e.target.value })} value={this.state.billingStreetaddress || ''} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.billingStreetaddress}</span>}

                                </div>
                                {/* End .form-group */}

                                <div className="form-group required-field">
                                    <label>City  </label>


                                    <input type="text" className="form-control form-control-sm" name="billingCity" onChange={(e) => this.setState({ billingCity: e.target.value })} value={this.state.billingCity || ""} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.billingCity}</span>}


                                </div>
                                {/* End .form-group */}

                                <div className="form-group">
                                    <label>State/Province</label>

                                    <input type="text" className="form-control form-control-sm" name="billingStateProvince" onChange={(e) => this.setState({ billingStateProvince: e.target.value })} value={this.state.billingStateProvince || ""} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.billingStateProvince}</span>}


                                    {/* End .select-custom */}
                                </div>
                                {/* End .form-group */}

                                <div className="form-group required-field">
                                    <label>Zip/Postal Code </label>


                                    <input type="text" className="form-control form-control-sm" name="billingPostalcode" onChange={(e) => this.setState({ billingPostalcode: e.target.value })} value={this.state.billingPostalcode || ""} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.billingPostalcode}</span>}


                                </div>

                                <hr className='dashed-line' />
                                <label className="modal-title pad-10">Shipping Address</label>
                                <div>
                                    <input type="checkbox" id="vehicle1" name="vehicle1" checked={this.state.copyChecked} onChange={this.handleChangeCheckBox} />
                                    <label className="pl-2 " for="vehicle1"><b> Same as billing address</b></label>
                                </div>
                                <div className="form-group required-field">
                                    <label>First Name </label>
                                    <input type="text" className="form-control form-control-sm" name="firstname" onChange={(e) => this.setState({ firstName: e.target.value })} value={this.state.firstName || ""} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.firstName}</span>}
                                </div>
                                {/* End .form-group */}

                                <div className="form-group required-field">
                                    <label>Last Name </label>
                                    <input type="text" className="form-control form-control-sm" name="lastname" onChange={(e) => this.setState({ lastName: e.target.value })} value={this.state.lastName || ""} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.lastName}</span>}
                                </div>
                                {/* End .form-group */}

                                <div className="form-group">
                                    <label>Company </label>
                                    <input type="text" className="form-control form-control-sm" name="company" onChange={(e) => this.setState({ company: e.target.value })} value={this.state.company || ""} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.company}</span>}
                                </div>
                                {/* End .form-group */}

                                <div className="form-group required-field">
                                    <label>Street Address </label>
                                    <input type="text" className="form-control form-control-sm" name="streetaddress" onChange={(e) => this.setState({ streetAddress: e.target.value })} value={this.state.streetAddress || ""} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.streetAddress}</span>}

                                </div>
                                {/* End .form-group */}

                                <div className="form-group required-field">
                                    <label>City  </label>
                                    <input type="text" className="form-control form-control-sm" name="city" onChange={(e) => this.setState({ city: e.target.value })} value={this.state.city || ""} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.city}</span>}
                                </div>
                                {/* End .form-group */}

                                <div className="form-group">
                                    <label>State/Province</label>
                                    <input type="text" className="form-control form-control-sm" name="stateProvince" onChange={(e) => this.setState({ stateProvince: e.target.value })} value={this.state.stateProvince || ""} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.stateProvince}</span>}
                                    {/* End .select-custom */}
                                </div>


                                <div className="form-group required-field">
                                    <label>Zip/Postal Code </label>
                                    <input type="text" className="form-control form-control-sm" name="postalcode" onChange={(e) => this.setState({ postalCode: e.target.value })} value={this.state.postalCode || ""} autoComplete="off" />
                                    {errors && isAddressSubmited && <span className="error-message">{errors.postalCode}</span>}
                                </div>
                                {/* End .form-group */}


                                <div className="form-group required-field">
                                    <label>Phone Number </label>
                                    <div className="form-control-tooltip">
                                        <input type="text" className="form-control form-control-sm" name="phoneNumber" value={this.state.phoneNumber || ""} onChange={(e) => this.setState({ phoneNumber: e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1') })} autoComplete="off" />
                                        {errors && isAddressSubmited && <span className="error-message">{errors.phoneNumber}</span>}
                                    </div>
                                    {/* End .form-control-tooltip */}
                                </div>
                                {/* End .form-group */}


                            </div>
                            {/* End .modal-body  */}

                            <div className="modal-footer">
                                <button type="button" className="btn btn-sm" data-dismiss="modal" onClick={this.onCloseOfficeModal} >Cancel</button>
                                <button type="submit" className="btn btn-primary btn-sm show-color">Save changes</button>
                            </div>
                            {/* End .modal-footer */}
                        </form>
                        {/* </div> */}
                    </Modal>



                    <Footer />

                </div>
            </React.Fragment>
        )


    }
}

CorporateProductCart.propTypes = {
    doCorporateCartListRes: PropTypes.any,
    doCorporateCartUpdateRes: PropTypes.any,
    doCorporateProductRemoveRes: PropTypes.any,
    doCorporateShowAddressListRes: PropTypes.any,
    doCorporateAddAddressRes: PropTypes.any,
    doCorporateDeleteAddressRes: PropTypes.any,
    doCsvUploadRes: PropTypes.any,
    doShowBillingRes: PropTypes.any,
    doBillingUpdateRes: PropTypes.any
};

const mapStateToProps = createStructuredSelector({
    doCorporateCartListRes: doCorporateCartListRes,
    doCorporateCartUpdateRes: doCorporateCartUpdateRes,
    doCorporateProductRemoveRes: doCorporateProductRemoveRes,
    doCorporateShowAddressListRes: doCorporateShowAddressListRes,
    doCorporateAddAddressRes: doCorporateAddAddressRes,
    doCorporateDeleteAddressRes: doCorporateDeleteAddressRes,
    doCsvUploadRes: doCsvUploadRes,
    doShowBillingRes: doShowBillingRes,
    doBillingUpdateRes: doBillingUpdateRes
});

function mapDispatchToProps(dispatch) {
    return {
        showCorporateCartList: (data) => dispatch(showCorporateCartList(data)),
        updateCorporateCart: (data) => dispatch(updateCorporateCart(data)),
        corporateProductRemove: (data) => dispatch(corporateProductRemove(data)),
        corporateAddressShowList: (data) => dispatch(corporateAddressShowList(data)),
        corporateAddressAdd: (data) => dispatch(corporateAddressAdd(data)),
        corporateAddressDelete: (data) => dispatch(corporateAddressDelete(data)),
        uploadCsv: (data) => dispatch(uploadCsv(data)),
        showBillingAddress: (data) => dispatch(showBillingAddress(data)),
        updateBillingAdd: (data) => dispatch(updateBillingAdd(data))
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(CorporateProductCart)
